import * as React from 'react'
import { useBulkActionContext } from '../BulkActionContext'
import { GridRowId } from '@mui/x-data-grid-pro'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'

type Props = {
  id: GridRowId
}

export const BulkActionErrorCell: React.FC<Props> = ({ id }) => {
  const {
    state: { errors },
  } = useBulkActionContext()

  const errDescription = (errors.get(id) ?? []).join(', ')

  return (
    <Tooltip title={errDescription}>
      <Typography
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {errDescription}
      </Typography>
    </Tooltip>
  )
}
BulkActionErrorCell.displayName = 'BulkActionErrorCell'
